import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';

import style from './index.module.scss';


@Component
export default class FraudHome extends Vue {
  private render() {
    return (
      <div class={style.fraudContainer}>
        <div class={style['section-1']}></div>
        <div class={style['section-2']}></div>
        <div class={style['section-3']}></div>
        <div class={style['section-4']}></div>
        <div class={style['section-5']}></div>
      </div>
    );
  }
}
